export const styles = ({ fontSize, readOnly, rows }) => ({
  root: {
    width: '100%',
    padding: '2px',
    border: !readOnly ? '1px solid #eee' : 'none',
    borderRadius: !readOnly ? '6px' : '0',
    '&:hover': !readOnly
      ? {
          border: '1px solid #000',
        }
      : null,
    '&:focus-within': !readOnly
      ? {
          borderColor: '#000',
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: '0 0 0 1px #003BBA',
        }
      : null,
  },
  toolbar: {
    minHeight: '0',
    position: 'relative',
    width: '100%',
    borderBottom: '2px solid #eee',
    marginBottom: '5px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'start',
  },
  button: {
    minWidth: '0',
  },
  editable: {
    padding: '10px',
    height:
      rows === 'auto'
        ? 'auto'
        : fontSize.includes('px')
        ? `${rows}em`
        : `${rows}px`,
    overflowY: readOnly ? 'hidden' : 'scroll',
    overflowX: 'hidden',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    '& p': {
      fontSize,
    },
    '& ul': {
      fontSize,
    },
    '& ol': {
      fontSize,
    },
    '& a': {
      fontSize,
    },
  },
})
